export default {
  root: {
    height: 6,
  },
};
